import { size } from 'lodash';
import PropTypes from 'prop-types';
import { Component } from 'react';

import UsersModal from 'hb-react/shared/components/DesignSystem/UsersModal';

import Following from './Following';

import style from './index.module.scss';

class Followings extends Component {
  state = {
    usersModalIsOpen: false,
  };

  showUsersModal = () => this.setState({ usersModalIsOpen: true });
  hideUsersModal = () => this.setState({ usersModalIsOpen: false });

  loadMoreFollowers() {
    const {
      total,
      total_followers_to_display: totalFollowersToDisplay,
      topic_id: topicId,
    } = this.props;
    const { usersModalIsOpen } = this.state;

    if (total <= totalFollowersToDisplay) {
      return null;
    }

    return (
      <li className="users-listing__total">
        <a onClick={this.showUsersModal} role="button">
          + {total - totalFollowersToDisplay}
        </a>
        {usersModalIsOpen && (
          <UsersModal
            onCloseModal={this.hideUsersModal}
            routes={{
              fetchUsers: Routes.topics_topic_followings_path(topicId),
            }}
            title={I18n.t('web.topics.followers.other')}
            responseCallback={(response) => ({
              users: response.followings.map((following) => following.user),
              total: response.total,
            })}
            screenReadersCloseButtonText={s__(
              'TopicsAccessibility|Close the topic followers list window',
            )}
          />
        )}
      </li>
    );
  }

  renderFollowings = () => {
    const { followings, total_followers_to_display: totalFollowersToDisplay } =
      this.props;

    return followings
      .slice(0, totalFollowersToDisplay)
      .filter((following) => following)
      .map((following) => (
        <Following key={following.get('id')} following={following.toJS()} />
      ));
  };

  render() {
    const {
      children,
      followings,
      sidebar_rendering: sidebarRendering,
    } = this.props;

    if (sidebarRendering) {
      return (
        <section className="deprecated--visuallyhidden--lap-and-up soft-half--bottom soft-double-half bordered--sides bordered--bottom">
          <h2 className="h2">
            {I18n.t('web.topics.followers', {
              count: size(followings),
            })}
          </h2>

          <ul className="users-listing__user user-listing__user-overlap push-half--left palm--soft--bottom">
            {this.renderFollowings()}
            {this.loadMoreFollowers()}
          </ul>
        </section>
      );
    }

    return (
      <div
        className={`deprecated--visuallyhidden--palm ${style.component}`}
        data-testid="followings"
      >
        <ul className="users-listing__user user-listing__user-overlap inline-block f-size--1-2 push-quarter--right">
          {this.renderFollowings()}
          {this.loadMoreFollowers()}
        </ul>

        {children}
      </div>
    );
  }
}

Followings.propTypes = {
  children: PropTypes.node,
  sidebar_rendering: PropTypes.bool,
  total_followers_to_display: PropTypes.number,
};

Followings.defaultProps = {
  children: null,
  sidebar_rendering: false,
  total_followers_to_display: 10,
};

export default Followings;
